/* Dansk katalog for locale-closing-annual-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  "clo.importedArchiveTitle": "Importeret årsgrundlag",
  "clo.importedArchiveHelp": "Året viser historik fra det tidligere system. Kontrollér tallene i rapporterne. Ny årsafslutning kræver komplet regnskabsgrundlag. Importen dokumenterer ikke indberetning.",
  "clo.importedArchiveResult": "Resultat for {year}: {amount}",

  'clo.incompleteBasisTitle': 'Regnskabsgrundlaget er ufuldstændigt',
  'clo.incompleteBasisText': 'Årsafslutningen er spærret, indtil journaldækningen er komplet. Eksisterende dokumenter er stadig tilgængelige fra bilags- og dokumentvisningerne.',
  'clo.finalReview.title': 'Forudsætninger og slutkontrol',
  'clo.finalApproval.title': 'Samlet slutgodkendelse',
  'clo.finalApproval.bank': 'Bank- og beholdningsafstemning',
  'clo.finalApproval.gainLoss': 'Regnskabsmæssig og skattemæssig gevinst/tab',
  'clo.finalApproval.differences': 'Permanente og midlertidige forskelle',
  'clo.finalApproval.assumptions': 'Forudsætninger og manuelle tilsidesættelser',
  'clo.finalApproval.confirm': 'Jeg har kontrolleret grundlaget og godkender, at året afsluttes. Godkender og tidspunkt gemmes i historikken.',
  'clo.finalApproval.button': 'Godkend og afslut året',
  'clo.finalApproval.statement': 'Jeg har kontrolleret bogføring, afstemninger, skat, årsregnskab og dokumenterede forudsætninger.',
  'clo.finalApproval.audit': 'Godkendt af {name} {time}.',
  'clo.finalApproval.required': 'Samlet slutgodkendelse kræves, før året kan afsluttes.',
  'clo.closed.subtitleTaxPendingWithoutAnnual': 'Regnskabsåret er afsluttet. Fortsæt med skattemeldingen.',
  'clo.status.ready': 'Klar',
  'clo.status.needsTreatment': 'Kræver behandling',
  'clo.status.notApplicable': 'Ikke relevant',
  'clo.group.chart': 'Kontoplan',
  'clo.group.equity': 'Aktiekapital og egenkapital',
  'clo.group.bank': 'Bank',
  'clo.group.cash': 'Mønter og sedler',
  'clo.group.vat': 'Moms',
  'clo.group.purchases': 'Køb og bilag',
  'clo.group.sales': 'Salg og kunder',
  'clo.group.payroll': 'Løn og pension',
  'clo.group.assets': 'Varelager, aktiver og investeringer',
  'clo.group.periodisation': 'Rigtigt år og mulige krav',
  'clo.group.final': 'Skat, årsregnskab og afslutning',
  'clo.periodisation.title': 'Rigtigt år og mulige krav',
  'clo.periodisation.subtitle': 'Tjek, om indtægter og udgifter hører til det rigtige år, og om virksomheden har uafklarede krav eller forpligtelser for {{year}}.',
  'clo.periodisation.unsupported': 'Denne kontrol understøtter norske regnskabsprofiler fra 2022. Land, selskabsform eller regnskabsramme skal vurderes særskilt.',
  'clo.periodisation.stale': 'Regnskabsgrundlaget er ændret. Kontroller vurderingerne igen, før du gemmer.',
  'clo.periodisation.unresolved': 'Der er dokumenterede uløste forhold. Bogfør eller afklar dem, før gruppen kan blive klar.',
  'clo.periodisation.reviewRequired': 'Bekræft de to kontroller nedenfor, før året afsluttes.',
  'clo.periodisation.reconciled': 'Indtægter, udgifter og mulige krav er gennemgået uden uløste forhold.',
  'clo.periodisation.unavailable': 'Kontrolgrundlaget kunne ikke indlæses.',
  'clo.periodisation.sectionTitle': 'Indtægter og udgifter omkring nytår',
  'clo.periodisation.sectionHelp': 'Tjek, om salg, køb, forudbetalinger eller arbejde uden faktura hører til {{year}} eller næste år. Datoen alene giver ikke altid svaret.',
  'clo.periodisation.reviewed': 'Jeg har tjekket dette, også forhold, der ikke ligger i Plumme.',
  'clo.periodisation.optionalNote': 'Tilføj detaljer (valgfrit)',
  'clo.periodisation.cutOffReviewed': 'Jeg har tjekket, at salg og køb omkring nytår hører til det rigtige år.',
  'clo.periodisation.prepaymentsReviewed': 'Jeg har tjekket betalinger, der vedrører næste år, for eksempel abonnement eller leje.',
  'clo.periodisation.accrualsReviewed': 'Jeg har tjekket omkostninger og indtægter for året, selv om fakturaen kommer senere.',
  'clo.periodisation.unbilledRevenueReviewed': 'Jeg har tjekket arbejde, der er leveret, men endnu ikke faktureret.',
  'clo.periodisation.documentationNote': 'Hvilke bilag eller aftaler har du tjekket?',
  'clo.periodisation.documentationHelp': 'Skriv gerne, hvilke bilag eller aftaler du tjekkede.',
  'clo.periodisation.unresolvedIssues': 'Er noget stadig bogført på det forkerte år eller ikke afklaret?',
  'clo.periodisation.foundDocuments': 'Plumme fandt {{count}} bilag omkring nytår, som du kan tjekke. Referencerne gemmes automatisk med gennemgangen.',
  'clo.periodisation.foundHelp': 'Listen viser mulige kontrolpunkter, ikke fejl. Leveringsdatoen kan være en anden end fakturadatoen.',
  'clo.periodisation.showDocuments': 'Vis bilagene',
  'clo.periodisation.sale': 'salg',
  'clo.periodisation.purchase': 'køb',
  'clo.periodisation.issueSummary': 'Uløste periodiseringer',
  'clo.periodisation.notAnswered': 'Ikke besvaret',
  'clo.periodisation.noUnresolved': 'Nej',
  'clo.periodisation.hasUnresolved': 'Ja',
  'clo.periodisation.openPosting': 'Åbn fri postering',
  'clo.periodisation.postingDescription': 'Periodisering ved årsafslutning',
  'clo.periodisation.save': 'Gem gennemgang',
  'clo.periodisation.saved': 'Gennemgangen er gemt. Status følger dokumentationen og regnskabsgrundlaget.',
  'clo.periodisation.saveError': 'Kunne ikke gemme gennemgangen.',
  'clo.periodisation.refresh': 'Indlæs opdateret grundlag',
  'clo.periodisation.back': 'Tilbage til årsafslutning',
  'clo.periodisation.plansTitle': 'Periodiseringsplaner',
  'clo.periodisation.plansHelp': 'Bogfør først købet på en konto for forudbetalte omkostninger. Plumme flytter derefter omkostningen måned for måned uden at bogføre bank eller leverandørgæld igen.',
  'clo.periodisation.sourcePurchase': 'Bogført køb',
  'clo.periodisation.selectPurchase': 'Vælg køb',
  'clo.periodisation.startDate': 'Første periode',
  'clo.periodisation.periodCount': 'Antal måneder',
  'clo.periodisation.prepaidAccount': 'Konto for forudbetalt',
  'clo.periodisation.costAccount': 'Omkostningskonto',
  'clo.periodisation.planNote': 'Dokumentation',
  'clo.periodisation.createPlan': 'Opret periodiseringsplan',
  'clo.periodisation.noPlans': 'Ingen periodiseringsplaner for dette år.',
  'clo.periodisation.posted': 'bogført',
  'clo.periodisation.remaining': 'tilbage',
  'clo.periodisation.postThrough': 'Bogfør til og med',
  'clo.periodisation.postPeriods': 'Bogfør perioder',
  'clo.periodisation.changeFuturePlan': 'Ændr fremtidig plan',
  'clo.periodisation.nextDate': 'Næste periode',
  'clo.periodisation.remainingPeriods': 'Resterende måneder',
  'clo.periodisation.changeReason': 'Begrundelse',
  'clo.periodisation.cancelPlan': 'Afslut fremtidig plan',
  'clo.periodisation.cancelReason': 'Begrundelse',
  'clo.periodisation.planSaveError': 'Kunne ikke gemme periodiseringsplanen.',
  'clo.periodisation.planCreated': 'Periodiseringsplanen er oprettet.',
  'clo.periodisation.planPosted': 'Forfaldne perioder er bogført.',
  'clo.periodisation.planRevised': 'Den fremtidige plan er opdateret.',
  'clo.periodisation.planCancelled': 'Den fremtidige plan er afsluttet.',
  'clo.reopenReasonRequired': 'Beskriv, hvorfor regnskabsåret skal genåbnes.',
  'clo.reopenConfirm': 'Genåbn året',
  'clo.reopenWarning': 'Genåbning ophæver låsen og markerer senere årsafslutninger til ny kontrol. Handlingen logges.',
  'clo.reopenReason': 'Begrundelse',
  'clo.reopenReasonPlaceholder': 'For eksempel: korrektion af periodisering efter modtaget dokumentation',
  'clo.provisions.sectionTitle': 'Mulige krav og omkostninger',
  'clo.provisions.sectionHelp': 'Tjek, om noget, der skete før nytår, kan give virksomheden en omkostning senere, for eksempel en tvist eller garanti.',
  'clo.provisions.reviewed': 'Jeg har tjekket, om sådanne forhold findes, også uden for Plumme.',
  'clo.provisions.optionalNote': 'Tilføj detaljer (valgfrit)',
  'clo.provisions.obligationsReviewed': 'Jeg har tjekket, om virksomheden kan skylde penge på grund af noget, der allerede er sket.',
  'clo.provisions.estimatesReviewed': 'Jeg har noteret beløb og usikkerhed for sådanne sager, hvis de findes.',
  'clo.provisions.contingenciesReviewed': 'Jeg har tjekket garantier, tvister og andre mulige krav.',
  'clo.provisions.documentationNote': 'Hvad har du tjekket?',
  'clo.provisions.documentationHelp': 'Skriv kort, hvilke aftaler, sager eller andre kilder du har tjekket. Skriv også, hvis ingen sådanne forhold er kendt.',
  'clo.provisions.unresolvedIssues': 'Findes der mulige krav eller omkostninger, som stadig skal vurderes?',
  'clo.provisions.issueSummary': 'Uløste hensættelser eller vurderinger',
  'clo.provisions.postingDescription': 'Hensættelse ved årsafslutning',
  'clo.pension.title': 'Pensionsbetaling (OTP)',
  'clo.pension.subtitle': 'Afklar og afstem pension for indkomståret {{year}}.',
  'clo.pension.unsupported': 'OTP-kontrollen understøtter norske regnskabsprofiler fra 2022. Dette år eller regnskabsopsætningen skal vurderes særskilt.',
  'clo.pension.incomplete': 'Lønngrundlaget mangler gyldige bogførte pensionsbeløb eller betalingsdata. Kontroller lønkørslerne.',
  'clo.pension.drafts': 'Året har uafklarede lønudkast. Afklar dem, før OTP-kontrollen kan blive klar.',
  'clo.pension.stale': 'Grundlaget er ændret. Kontroller dokumentationen igen, før du gemmer en ny vurdering.',
  'clo.pension.conflict': 'Registreret pensionsaktivitet skal afstemmes og kan ikke sættes til ikke relevant.',
  'clo.pension.notApplicable': 'Dokumenteret vurdering: OTP er ikke relevant for dette indkomstår.',
  'clo.pension.noRecordedActivity': 'Der er ikke registreret ansatte, løn, pension eller relevante posteringer for året. OTP-kontrollen er ikke relevant ud fra oplysningerne i Plumme. Hvis virksomheden har haft ansatte eller pension i et andet system, skal oplysningerne gennemgås.',
  'clo.pension.manualReview': 'Vurder OTP manuelt',
  'clo.pension.reconciled': 'Pensionsgrundlag, betalinger og saldo er dokumenteret afstemt for indkomståret.',
  'clo.pension.reviewRequired': 'OTP-vurderingen er ikke færdig. Du kan gemme nu og fuldføre, når du har årsopgørelsen.',
  'clo.pension.basisTitle': 'Registreret pensionsgrundlag',
  'clo.pension.showRuns': 'Vis {{count}} lønkørsler og betalingsdetaljer',
  'clo.pension.configuredProvider': 'Registreret udbyder i lønopsætningen: {{name}}. Kontroller mod årsopgørelsen for dette år.',
  'clo.pension.signal.staffingRule': 'Registreret løn og stillingsprocenter peger mod OTP-pligt. Plumme har valgt «Ja», men mangler uafhængig bekræftelse af lønvilkår og medlemskab.',
  'clo.pension.signal.recordedPension': 'Pensionsaktivitet er registreret i Plumme og skal gennemgås.',
  'clo.pension.signal.unknown': 'Plumme kan ikke afgøre OTP-pligt sikkert ud fra de registrerede oplysninger. Fravær af løn alene er ikke fritagelse.',
  'clo.pension.prefillHelp': 'Forslagene nedenfor kommer fra Plumme, ikke fra pensionsudbyderens årsopgørelse. Kontroller dem mod årsopgørelsen, før afstemningen bekræftes.',
  'clo.pension.accountantReview': 'Avanceret kontrol (valgfri)',
  'clo.pension.externalPostings': 'Pension er også bogført uden for løn. Plumme kan ikke foreslå fuldstændige præmiebeløb her; kontroller regnskabet og årsopgørelsen.',
  'clo.pension.statementQuestion': 'Stemmer ansatte og beløb i pensionsudbyderens årsopgørelse med Plumme?',
  'clo.pension.statementUnchecked': 'Ikke kontrolleret endnu',
  'clo.pension.statementMatches': 'Ja, årsopgørelsen stemmer',
  'clo.pension.statementDiffers': 'Nej, beløbene er forskellige',
  'clo.pension.needsFurtherReview': 'Vurderingen kan gemmes nu, men disse oplysninger skal afklares, før OTP kan markeres som færdig.',
  'clo.pension.basisHelp': 'Estimaterne kommer fra bogførte lønkørsler i indkomståret. Betalingerne følger den faktiske betalingsdato og kan vedrøre tidligere lønår. Dette er ikke en fuld saldo på konto 2930, som også kan indeholde skyldig løn.',
  'clo.pension.accrued': 'Bogført OTP-estimat fra årets løn',
  'clo.pension.paid': 'Registreret pensionspræmie betalt i året',
  'clo.pension.noPayment': 'Ingen pensionsbetaling registreret',
  'clo.pension.noRuns': 'Ingen relevante bogførte lønkørsler. Det afgør ikke alene, om OTP er relevant.',
  'clo.pension.unpaidAtYearEnd': '{{count}} lønkørsler har pensionsestimat uden registreret betaling inden 31.12. Dokumenter eventuel restgæld og betaling efter årsskiftet.',
  'clo.pension.openPayments': 'Åbn pensionsbetalinger',
  'clo.pension.paymentScope': 'Pensionsbetalinger knyttet til lønngrundlag eller betalinger i {{year}}. Brug den faktiske betalingsdato, også ved betaling efter årsskiftet.',
  'clo.pension.back': 'Tilbage til OTP-afstemningen',
  'clo.pension.backToClosing': 'Tilbage til årsafslutning',
  'clo.pension.reviewTitle': 'Vurdering og dokumentation',
  'clo.pension.applicabilityHelp': 'Vurder ansættelsesforholdene og pensionsordningen for det år, der afsluttes. Den nuværende udbyderopsætning eller fravær af lønkørsler beviser ikke, at virksomheden er undtaget.',
  'clo.pension.rules': 'Se Skatteetatens vejledning',
  'clo.pension.applicability': 'Er OTP relevant for indkomståret?',
  'clo.pension.undecided': 'Ikke afklaret',
  'clo.pension.applicable': 'Ja – pension skal afstemmes',
  'clo.pension.notApplicableChoice': 'Nej – dokumenteret ikke relevant',
  'clo.pension.providerName': 'Pensionsudbyder (kontroller for året)',
  'clo.pension.providerAnnualPremium': 'Præmie for indkomståret (forslag fra Plumme)',
  'clo.pension.providerPaidPremiums': 'Præmie betalt i kalenderåret (fra Plumme)',
  'clo.pension.premiumDifference': 'Forskel mellem dokumenteret præmie og lønestimat',
  'clo.pension.paymentDifference': 'Forskel fra registrerede præmiebetalinger',
  'clo.pension.differenceExplanation': 'Forklaring og bilagsreferencer for forskelle',
  'clo.pension.differenceHelp': 'Påkrævet ved forskelle. Forklar periodisering, justeringer og betalinger bogført andre steder med bilagsreferencer. Uafklarede fejl skal rettes, før du bekræfter afstemningen.',
  'clo.pension.noteSuggestions': 'Hurtige kommentarer',
  'clo.pension.noteLabel.statementMissing': 'Årsopgørelse mangler',
  'clo.pension.noteLabel.statementCompared': 'Opgørelse tjekket',
  'clo.pension.noteLabel.differenceToCheck': 'Afvigelse skal undersøges',
  'clo.pension.noteLabel.paymentAfterYearEnd': 'Sen betaling',
  'clo.pension.noteLabel.noEmployees': 'Ingen ansatte',
  'clo.pension.noteLabel.belowThreshold': 'Under OTP-betingelserne',
  'clo.pension.note.statementMissing': 'Årsopgørelsen fra pensionsudbyderen er ikke modtaget. Afstemningen fuldføres, når den foreligger.',
  'clo.pension.note.statementCompared': 'Jeg har sammenlignet ansatte og præmiebeløb i årsopgørelsen med oplysningerne i Plumme.',
  'clo.pension.note.differenceToCheck': 'Der er en forskel mellem årsopgørelsen og Plumme, som skal undersøges.',
  'clo.pension.note.paymentAfterYearEnd': 'Pensionspræmie betalt efter årsskiftet skal kontrolleres mod årsopgørelsen.',
  'clo.pension.note.noEmployees': 'Jeg har kontrolleret ansættelsesforholdene for indkomståret. Virksomheden havde ingen ansatte.',
  'clo.pension.note.belowThreshold': 'Jeg har kontrolleret ansættelsesforhold og løn for indkomståret. Ingen af betingelserne for OTP-pligt var opfyldt.',
  'clo.pension.documentationNote': 'Dokumentation og begrundelse',
  'clo.pension.documentationHelp': 'Valgfrit: tilføj reference til årsopgørelse eller bilag. Hvis OTP ikke er relevant, så forklar hvorfor ud fra ansættelsesforholdene i året.',
  'clo.pension.save': 'Gem OTP-vurdering',
  'clo.pension.saved': 'OTP-vurderingen er gemt. Du kan vende tilbage og fuldføre senere.',
  'clo.pension.saveError': 'Kunne ikke gemme OTP-vurderingen.',
  'clo.pension.refresh': 'Indlæs opdateret grundlag',
  'clo.wealth.assetsHelp': 'Skattemæssig værdi af driftsmidler, inventar og varelager, der er bogført ved årets udgang.',
  'clo.wealth.sharesHelp': 'Aktier, andele, fonde og andre finansielle investeringer, der findes i saldobalancen.',
  'clo.wealth.otherHelp': 'Øvrige formueposter som bankindskud, tilgodehavender, mellemregninger og andre aktiver.',
  'clo.wealth.total': 'Samlet formue',
  'clo.wealth.totalHelp': 'Summen af de formueposter, Plumme kan læse fra bogføringen.',
  'clo.wealth.otherDebt': 'Anden gæld',
  'clo.wealth.otherDebtHelp': 'Gældsposter på konto 2100-2999 fra saldobalancen pr. 31.12.',
  'clo.wealth.totalDebtHelp': 'Samlet gæld pr. 31.12.',
  'clo.wealth.netHelp': 'Nettoformue er formue minus gæld.',
  'clo.wealth.assetsLongHelp': 'Skattemæssig værdi af anlægsaktiver (maskiner, inventar, biler), omsætningsaktiver og varelager, som selskabet ejer ved årets udgang. For anlægsaktiver bruges saldoafskrivning eller skattemæssig restværdi, ikke den regnskabsmæssige bogførte værdi.',
  'clo.wealth.sharesLongHelp': 'Aktier, andele og andre værdipapirer, som selskabet ejer. Efter fritaksmetoden skal aktier i datterselskaber også medtages i formuen. Værdien sættes normalt til anskaffelsessum eller skattemæssig indgangsværdi, ikke markedsværdi.',
  'clo.wealth.otherLongHelp': 'Øvrige formueposter, der ikke er driftsmidler, varelager eller aktier — fx bankindeståender, tilgodehavender fra salg, forudbetalte omkostninger, momstilgodehavende og mellemregninger.',
  'clo.wealth.debtLongHelp': 'Alt, hvad selskabet skylder pr. 31.12: banklån, kassekredit, leverandørgæld, skyldig skat/moms, udbyttegæld, mellemregning med ejeren og anden kort- og langfristet gæld.',
  'clo.addGainLossAccount': 'Tilføj gevinst- og tabskonto',
  'clo.ownerTransactions': 'Ydelser mellem selskabet og personlig ejer',
  'clo.ownerLoanToOwner': 'Har selskabet ydet lån, stillet sikkerhed, solgt eller udlejet til ejer eller nærtstående?',
  'clo.ownerLoanFromOwner': 'Har ejer eller nærtstående ydet lån, stillet sikkerhed, solgt eller udlejet til selskabet?',
  'clo.editDetails': 'Ret oplysninger',
  'clo.otherCompanyDetails': 'Andre oplysninger om selskabet',
  'clo.otherCompanyDetailsHelp': 'Kontrollér, at oplysningerne om ejerskab, koncernforhold og skattefrie overførsler er korrekte.',
  'clo.ownership': 'Ejerskab',
  'clo.foreignOwnership': 'Har udenlandsk ejerskab eller er omstruktureret på tværs af landegrænser',
  'clo.wasSubsidiary': 'Var datterselskab i en koncern i indkomståret',
  'clo.taxFreeTransfers': 'Har selskabet modtaget eller overført skattefrie aktiver eller forpligtelser',
  'clo.companyAndOwnership': 'Oplysninger om selskabet og ejerskab',
  'clo.fillSharesInfo': 'Udfyld alle oplysninger om aktier og investeringer',
  'clo.addShare': 'Tilføj aktie',
  'clo.addOtherInvestments': 'Tilføj andre investeringer',
  'clo.otherOperatingIncome': 'Anden driftsindtægt',
  'clo.totalOperatingIncome': 'Sum driftsindtægt',
  'clo.goodsCost': 'Vareforbrug',
  'clo.payrollCost': 'Lønomkostning',
  'clo.otherOperatingCost': 'Anden driftsomkostning',
  'clo.totalOperatingCost': 'Sum driftsomkostning',
  'clo.financialIncome': 'Finansiel indtægt',
  'clo.financialCost': 'Finansiel omkostning',
  'clo.resultForYear': 'Årets resultat',
  'clo.equityAndDebt': 'Egenkapital og gæld',
  'clo.specification': 'Specifikation',
  'clo.inventoryValue': 'Værdi af varelager',
  'clo.receivableTaxValue': 'Skattemæssig værdi af tilgodehavende',
  'clo.equity': 'Egenkapital',
  'clo.payrollPensionSpec': 'Specifikation af løn- og pensionsomkostning',
  'clo.addItem': 'Tilføj post',
  'clo.addItemHelp': 'Vælg en konto, og tilføj en manuel ændring, der kun gælder udkastet til skattemelding.',
  'clo.viewDetails': 'Se detaljer',
  'clo.balanceDiscrepancy': 'Balanceafvigelse',
  'clo.filing': 'Indsendelse',
  'clo.readyForReview': 'Oplysningerne er klar til kontrol før indsendelse.',
  'clo.checkBusinessInfo': 'Kontrollér erhvervsoplysninger',
  'clo.sendToAuthority': 'Send til Skatteetaten',
  'clo.taxReturnFiled': 'Skattemeldingen er indsendt og registreret i Plumme.',
  'clo.cancelTaxReturn': 'Annuller og åbn skattemelding',
  'clo.taxReturnReopened': 'Skattemeldingen er åbnet for rettelse.',
  'clo.yearClosingRequiredTitle': 'Årsafslutningen skal gennemføres først',
  'clo.yearClosingRequiredForTax': 'Skattemeldingen åbnes, når regnskabsåret er afsluttet.',
  'clo.yearClosingRequiredForAnnual': 'Årsregnskabet åbnes, når regnskabsåret er afsluttet.',
  'clo.yearClosingRequiredBody': 'Regnskabsåret {year} kan tidligst afsluttes 1. januar {nextYear}. Efter årsafslutningen er året låst for regnskabsændringer, og skattemelding og årsregnskab kan gennemgås.',
  'clo.goToYearClosing': 'Gå til årsafslutning',
  'clo.costsAndTax': 'Omkostninger og skat',
  'clo.assessment': 'Vurdering:',
  'clo.group': 'Koncern:',
  'clo.aboutAnnualAccounts': 'Om årsregnskabet',
  'clo.noAnnualAccountsDutyEnk': 'Ingen pligt til årsregnskab for ENK',
  'clo.accountantHelpAnnual': 'Hjælp fra bogholder til at udarbejde årsregnskabet',
  'clo.accountantHelpAnnualHelp': 'Bruger selskabet en ekstern autoriseret bogholder til at udarbejde og indsende årsregnskabet? Det påvirker noteoplysningerne om revision og bogholder.',
  'clo.yesAccountant': 'Ja, vi bruger bogholder',
  'clo.noAccountant': 'Nej, vi bruger ikke bogholder',
  'clo.accountantHelpGeneral': 'Hjælp fra bogholder generelt',
  'clo.accountantHelpGeneralHelp': 'Har selskabet fået hjælp fra en ekstern autoriseret bogholder til at føre regnskabet i løbet af året? Det adskilles fra hjælp til at udarbejde selve årsregnskabet.',
  'clo.yesGotHelp': 'Ja, vi har fået hjælp af bogholder',
  'clo.noGotHelp': 'Nej, vi har ikke fået hjælp af bogholder',
  'clo.theFiling': 'Indsendelsen',
  'clo.theCompany': 'Selskabet',
  'clo.contactEmails': 'E-mail til kontaktpersoner',
  'clo.representativeName': 'Navn på en repræsentant for selskabet',
  'clo.accountantAndAudit': 'Bogholder og revision',
  'clo.shouldBeAudited': 'Skal årsregnskabet revideres?',
  'clo.shouldBeAuditedHelp': 'Revisionspligt gælder selskaber over visse grænseværdier. De fleste små AS er ikke revisionspligtige.',
  'clo.preparedByAccountant': 'Er årsregnskabet udarbejdet af en ekstern autoriseret bogholder?',
  'clo.assistedByAccountant': 'Har selskabet fået bistand fra en ekstern autoriseret bogholder?',
  'clo.operatingIncomeSection': 'Driftsindtægter',
  'clo.salesIncome': 'Salgsindtægt',
  'clo.salesIncomeHelp': 'Faktureret og bogført omsætning ekskl. moms.',
  'clo.totalOperatingIncome2': 'Sum driftsindtægter',
  'clo.operatingCostSection': 'Driftsomkostninger',
  'clo.goodsCostHelp': 'Indkøbte varer og direkte vareomkostninger bogført på 4xxx-konti.',
  'clo.payrollCostHelp': 'Løn, arbejdsgiverafgift og andre personaleomkostninger fra 5xxx-konti.',
  'clo.depreciationFixedAssets': 'Afskrivning på materielle anlægsaktiver',
  'clo.depreciationHelp': 'Årets regnskabsmæssige afskrivning hentet fra 60xx-konti.',
  'clo.totalOperatingCost2': 'Sum driftsomkostninger',
  'clo.operatingResult': 'Driftsresultat',
  'clo.financialItems': 'Finansielle poster',
  'clo.otherInterestIncome': 'Andre renteindtægter',
  'clo.otherInterestCost': 'Andre renteomkostninger',
  'clo.netFinancial': 'Netto finansielle poster',
  'clo.taxCost': 'Skatteomkostning',
  'clo.taxCostHelp': 'Skatteomkostningen hentes fra bogførte skatteomkostningskonti, når de findes.',
  'clo.resultAfterFinanceHelp': 'Årets resultat efter finansielle poster og bogført skatteomkostning.',
  'clo.transfersAndAllocations': 'Overførsler og dispositioner',
  'clo.totalTransfers': 'Sum overførsler og dispositioner',
  'clo.balanceAssets': 'Balance - Aktiver',
  'clo.fixedAssets': 'Anlægsaktiver',
  'clo.noFixedAssets': 'Ingen anlægsaktiver i saldobalancen.',
  'clo.totalFixedAssets': 'Sum anlægsaktiver',
  'clo.currentAssets': 'Omsætningsaktiver',
  'clo.noCurrentAssets': 'Ingen omsætningsaktiver i saldobalancen.',
  'clo.totalCurrentAssets': 'Sum omsætningsaktiver',
  'clo.balanceEquityDebt': 'Balance - Egenkapital og gæld',
  'clo.noEquityAccounts': 'Ingen egenkapitalkonti i saldobalancen.',
  'clo.noDebtAccounts': 'Ingen gældskonti i saldobalancen.',
  'clo.notes': 'Noter',
  'clo.assessmentType': 'Type vurdering',
  'clo.noUncertainty': 'Ingen usikkerhed',
  'clo.goingConcernUncertainty': 'Usikkerhed om fortsat drift',
  'clo.uncertaintyFreeText': 'Fritekst om usikkerheden (indsættes i noten):',
  'clo.notePh': 'Skriv en kommentar/note, der skal følge noten.',
  'clo.fteCount': 'Antal årsværk',
  'clo.noEmployees': 'Ingen medarbejdere',
  'clo.allInformation': 'Alle oplysninger',
  'clo.allInformationHelp': 'Gennemgå trinene til venstre. Når alt er bekræftet, kan dokumentpakken forberedes.',
  'clo.continueToSigning': 'Gå videre til underskrift',
  'clo.documentsHelp': 'Her er alle de dokumenter, der skal laves og underskrives som en del af årsregnskabet.',
  'clo.documentsSignerHelp': 'Bestyrelsen underskriver bestyrelsesmøde- og generalforsamlingsprotokollen. Både bestyrelsen og den administrerende direktør underskriver selve årsregnskabet.',
  'clo.docAnnualAccounts': 'Årsregnskab',
  'clo.docAnnualAccountsHelp': 'Årsregnskabet er færdigt, men skal underskrives.',
  'clo.docBoardProtocol': 'Bestyrelsesprotokol',
  'clo.docBoardProtocolHelp': 'Protokollen fra bestyrelsesmødet.',
  'clo.docGeneralAssembly': 'Generalforsamlingsprotokol',
  'clo.docGeneralAssemblyHelp': 'Protokollen fra generalforsamlingen.',
  'clo.tabOverview': 'Oversigt',
  'clo.boardTabHelp': 'Her laver du protokollen fra det bestyrelsesmøde, der afholdes for at behandle årsregnskabet.',
  'clo.generalTabHelp': 'Her laver du protokollen fra den generalforsamling, der godkender årsregnskabet.',
  'clo.meetingDetails': 'Mødedetaljer',
  'clo.meetingDate': 'Dato',
  'clo.meetingTime': 'Tidspunkt',
  'clo.meetingLocation': 'Sted',
  'clo.meetingLocationPh': 'For eksempel Oslo',
  'clo.attendees': 'Deltagere',
  'clo.attendeesHelp': 'Bestyrelsen er foreslået. Fjern dem, der ikke mødte — protokollen angiver kun, at mødet var beslutningsdygtigt, når flertallet faktisk var til stede.',
  'clo.attendeesEmpty': 'Hent rollerne fra Enhetsregisteret i oversigten først.',
  'clo.shareRegister': 'Aktionærer',
  'clo.shareRegisterHelp': 'Aktionærerne findes ikke i noget åbent register, så de registreres her. Listen bruges i generalforsamlingsprotokollen.',
  'clo.shareholderName': 'Navn',
  'clo.shares': 'Aktier',
  'clo.proxy': 'Repræsenteret ved fuldmægtig',
  'clo.present': 'Til stede',
  'clo.remove': 'Fjern',
  'clo.addShareholder': 'Tilføj aktionær',
  'clo.sharesPresent': 'Aktier til stede',
  'clo.allocationTitle': 'Disponering af årets resultat for {year}',
  'clo.allocResult': 'Årets resultat efter skat',
  'clo.allocDividend': 'Udbetaling af udbytte til ejere',
  'clo.allocRetained': 'Restbeløb, der overføres til egenkapital',
  'clo.allocCovered': 'Restbeløb, der dækkes af egenkapital',
  'clo.protocolMissing': 'Mangler, før protokollen kan laves: {fields}',
  'clo.missingDate': 'dato',
  'clo.missingLocation': 'sted',
  'clo.missingAttendees': 'deltagere',
  'clo.missingShareholders': 'aktionærer',
  'clo.missingShareholdersPresent': 'mindst én aktionær til stede',
  'clo.generateProtocol': 'Lav protokol',
  'clo.protocolGenerating': 'Laver protokol…',
  'clo.protocolGenerated': 'Protokollen er lavet',
  'clo.protocolFailed': 'Kunne ikke lave protokollen.',
  'svc.protocolUnavailable': 'Protokolmodulet er ikke indlæst.',
  'clo.signersTitle': 'Hvem skal underskrive',
  'clo.signersHelp': 'Navne og roller kommer fra Enhetsregisteret. E-mail findes ikke der, så den skal du selv udfylde.',
  'clo.signersEmpty': 'Der er ikke registreret roller endnu. Hent dem fra Enhetsregisteret for at komme i gang.',
  'clo.signersMissingEmail': 'Underskriften kan ikke sendes ud, før alle har en e-mail: {names}',
  'clo.signerEmailPh': 'E-mail til underskrift',
  'clo.rolesFetch': 'Hent fra Enhetsregisteret',
  'clo.rolesFetching': 'Henter…',
  'clo.rolesFetched': 'Roller hentet fra Enhetsregisteret',
  'clo.meetingChair': 'Dirigent',
  'clo.meetingChairHint': 'Dirigenten og én anden underskriver protokollen, jf. aksjeloven § 5-16.',
  'clo.meetingChairNone': 'Ikke valgt — bestyrelsen underskriver',
  'clo.docSentToEmail': 'Sendt til underskrift: {names}',
  'clo.docSendFailed': 'Kunne ikke sende til underskrift.',
  'clo.sendReminder': 'Send påmindelse',
  'clo.reminderSent': 'Påmindelse sendt til {names}',
  'clo.viewPdf': 'Vis PDF',
  'clo.sign': 'Underskriv',
  'clo.markSigned': 'Markér som underskrevet',
  'clo.docAwaitingSignature': 'Sendt til underskrift — venter',
  'clo.docSigned': 'Underskrevet',
  'clo.docNotSigned': 'Ikke underskrevet',
  'clo.docSentToast': '{document} sendt til underskrift',
  'clo.docSignedToast': '{document} markeret som underskrevet 🟣',
  'clo.signingHelp': 'Årsregnskabet skal underskrives før indsendelse. Underskriftsstatus gemmes på virksomheden.',
  'clo.signing': 'Underskriver',
  'clo.continueToFiling': 'Gå videre til indsendelse',
  'clo.markAnnualSent': 'Indsend årsregnskab',
  'clo.annualMarkedFiled': 'Årsregnskabet er markeret som indsendt i Plumme.',
  'clo.cancelAnnualAccounts': 'Annullér og genåbn årsregnskabet',
  'clo.annualReopened': 'Årsregnskabet er genåbnet til rettelse.',
  'clo.backToStart': 'Tilbage til start',
  'clo.yearClosed': 'Regnskabsåret er afsluttet',
  'clo.yearClosedHelp': 'Året er låst for ændringer. Du kan genåbne det, hvis du skal rette noget.',
  'clo.fileTaxReturn': 'Indsend skattemeldingen',
  'clo.markTaxReturnFiled': 'Markér skattemeldingen som indsendt',
  'clo.goToTaxReturn': 'Gå til skattemeldingen',
  'clo.openTaxReturn': 'Åbn skattemeldingen',
  'clo.fileAnnualAccounts': 'Indsend årsregnskabet',
  'clo.markAnnualFiled': 'Markér årsregnskabet som indsendt',
});
